export default __webpack_public_path__ + "static/media/3127.277688e4.jpg";